import * as React from "react";
const SvgNestedTools = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "#0B4566", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M36 33l-3-3v6l3-3z" }));
export default SvgNestedTools;
